import { Injectable } from '@angular/core';
import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CreateAxiosDefaults } from 'axios';
import {CONSTANT_CONFIG, LOCAL_STORAGE_KEYS} from '../config/constants';
import { NotificationService } from './notification.service';
import { LocalStorageService } from './local-storage.service';
import { AxiosServiceNotification, AxiosServiceResponseProcessor, AxiosServiceResponseProcessorOutput } from './axiosServiceResponseProcessor.service';


export interface AxiosServicePostOtherOptions {
    toastReceivedErrorMessage?: boolean,
    [key: string]: any,
  }
  export interface AxiosServicePostOptions {
    config?: AxiosRequestConfig<any>,
    otherOptions?: AxiosServicePostOtherOptions,
  }

  export interface ApplicationResponse {
    error?: boolean,
    message?: string,
    data?: any
  }
  type LegacyApplicationResponse = {[key: string]: any} | any[];
  type AxiosServicePostReturnType = boolean | ApplicationResponse | LegacyApplicationResponse; //legacy until moving all



  // export interface

  const AXIOS_DEFAULT_INSTANCE_CONFIG_CREATOR = (token: string): CreateAxiosDefaults => ({
    baseURL: CONSTANT_CONFIG.DATA_WAREHOUSE_API_URL,
    headers: {
      "Content-Type": "application/json",
      ...(token ? {
        Authorization: `Bearer ${token}`
      } : {}),
    },
  });

  

  @Injectable({
    providedIn: 'root'
  })
  export class AxiosService {

    private _instance: AxiosInstance;

    constructor(
      private localStorageService  : LocalStorageService,
      private notificationService: NotificationService,
      private axiosServiceResponseProcessor: AxiosServiceResponseProcessor,
    ) {
      console.log("in AxiosService constructor");
      this.init();
    }
    init(){
      console.log("in AxiosService init");
      // this._instance = axios.create(AXIOS_DEFAULT_INSTANCE_CONFIG_CREATOR(this.localStorageService.get(LOCAL_STORAGE_KEYS.ACCESS_TOKEN)));
      this._instance = axios.create(AXIOS_DEFAULT_INSTANCE_CONFIG_CREATOR(this.localStorageService.get(LOCAL_STORAGE_KEYS.ACCESS_TOKEN
        )));
    }
    get axios(){
      console.log("axios service has been called");
      console.log("here the instance of axios servic,",AXIOS_DEFAULT_INSTANCE_CONFIG_CREATOR(''));
      return this._instance;
    }
    async post(url: string, data?: any, options: AxiosServicePostOptions = { otherOptions : { toastReceivedErrorMessage: true  } }) : Promise<AxiosServicePostReturnType>
    {
      try {
        const res: AxiosResponse = await this.axios.post(url, data, options.config);
        if(res.data.error === true){
          if(options.otherOptions.toastReceivedErrorMessage) this.notificationService.showToastr('danger', res.data.message ?? "Something went wrong.");
          return false;
        }
        if(res.data.data?.error === true){
          if(options.otherOptions.toastReceivedErrorMessage) this.notificationService.showToastr('danger', res.data.data.message ?? "Something went wrong.");
          return false;
        }
        return res.data as ApplicationResponse;
      } catch (err) {
        if (err instanceof AxiosError) { //AxiosError {code, message, request, reponse}
          console.log(err.response.data.message ?? "Something went wrong.");
          if(options.otherOptions.toastReceivedErrorMessage) this.notificationService.showToastr("danger",err.response.data.message ?? "Something went wrong.");
        }
        return false;
      }
    }

    async request(
      method: AxiosServiceMethods,
      url: string,
      data?: any,
      options?: AxiosServiceRequestOptions
    ): Promise<AxiosServiceReturn> {
      console.dir(options);
      options = {
        ...options,
        loadingStatusIndicatorConfig: {
          showGlobalLoader: true,
          loaderObservableIdentifier: '$globalLoader',
          ...options?.loadingStatusIndicatorConfig,
        },
        notificationConfig: {
          ...options?.notificationConfig,
          errorHandlingConfig: {
            showGlobalFailureMessageNotification: true,
            showGlobalValidationErrorsNotification: false,
            ...options?.notificationConfig?.errorHandlingConfig,
          },
          successHandlingConfig: {
            showGlobalSuccessMessageNotification: true,
            ...options?.notificationConfig?.successHandlingConfig,
          },
        },
        returnConfig: {
          returnSuccessStatus: true,
          ...options?.returnConfig,
          dataConfig: {
            returnData: true,
            returnErrorData: true,
            ...options?.returnConfig?.dataConfig,
          },
          messagesConfig: {
            returnFailureMessage: true,
            returnSuccessMessage: true,
            returnValidationErrors: true,
            ...options?.returnConfig?.messagesConfig,
          },
        },
        statusMessageConfig: {
          isResourceCRUD: true,
          resourceName: "Resource",
        }
      };

      console.log('options', options);

      const res: AxiosResponse | undefined = await this.axios({
          method,
          url,
          data,
          ...options?.axiosConfig,
        })
        .catch((error: AxiosError): AxiosResponse | undefined =>{
          // console.log(error.config);
          if (error.response) { // bad status code
            // const res : ErrorResponse = error.reponse.data;
            // console.log(error.response.data);
            // console.log(error.response.status);
            // console.log(error.response.headers);
            return error.response;
          } else if (error.request) {// no response was received
            // console.log(error.request); // the request, xmlhttprequest object
            return undefined;
          } else { // Something happened in setting up the request that triggered an Error
            // console.log('Error', error.message); // the error message
            return undefined;
          }
        });
      const processorResult: AxiosServiceResponseProcessorOutput = this.axiosServiceResponseProcessor.process(res, options, { method, url, data });

      processorResult.notifications.forEach((axiosServiceNotification: AxiosServiceNotification) => {
        this.notificationService.showToastr(axiosServiceNotification.status, axiosServiceNotification.title, axiosServiceNotification.otherOptions, axiosServiceNotification.milliseconds);
      });

      return processorResult.return;
    }
  }

  export type AxiosServiceMethods = "POST" | "GET" | "PUT" | "DELETE" | "PATCH" | "HEAD";
  export interface AxiosServiceReturn {
    successful?: boolean,
    data?: any,
    messages?: {
      failureMessage?: string,
      validationErrors?: {
        [key: string]: string[],
      },
      successMessage?: string,
    },
  }

  export interface AxiosServiceRequestOptions {
    axiosConfig?: AxiosRequestConfig<any>,
    loadingStatusIndicatorConfig?: AxiosServiceRequestLoadingStatusIndicatorConfig,
    notificationConfig?: AxiosServiceRequestNotificationConfig,
    returnConfig?: AxiosServiceRequestReturnConfig,
    statusMessageConfig?: AxiosServiceStatusMessageConfig,
  }

  export interface AxiosServiceRequestLoadingStatusIndicatorConfig {
    showGlobalLoader?: boolean,
    loaderObservableIdentifier?: string,
  }
  export interface AxiosServiceRequestNotificationConfig {
    errorHandlingConfig?: {
      showGlobalFailureMessageNotification?: boolean, //def: true
      showGlobalValidationErrorsNotification?: boolean, //def: false
    },
    successHandlingConfig?: {
      showGlobalSuccessMessageNotification?: boolean, //def: true
    },
  }
  export interface AxiosServiceRequestReturnConfig {
    dataConfig?: {
      returnData?: boolean,
      /**
       * @description If true, returns the reponse body even in case of a client/server error.
       */
      returnErrorData?: boolean,
      returnOnError?: any, // overrides returnErrorData flag
    },
    messagesConfig?: {
      returnFailureMessage?: boolean,
      returnValidationErrors?: boolean,
      returnSuccessMessage?: boolean,
    },
    returnSuccessStatus?: boolean, //def: true
  }

  // request parsing service
    // error parsing
    // success parsing (or lack of)

  export interface AxiosServiceStatusMessageConfig {
    successMessage?: string, //overrides
    failureMessage?: string, //overrides
    isResourceCRUD?: boolean, //def: true, if false, default success and failure messages will be used (unless overriden by successMessage, failureMessage)
    resourceName?: string,
    actionName?: "CREATE" | "UPDATE" | "DELETE" | "READ",
  }


  export const AxiosServiceActionNameToActionVerbMap = {
    "CREATE": "created",
    "UPDATE": "updated",
    "DELETE": "deletd",
    "READ": "fetched",
  };



    // {
    //   loadingStatusIndicatorConfig: {
    //     showGlobalLoader: true,
    //     loaderObservableIdentifier: '$globalLoader',
    //   },
    //   notificationConfig: {
    //     resourceName: "Resource",
    //     errorHandlingConfig: {
    //       showGlobalFailureMessageNotification: true,
    //       showGlobalValidationErrorsNotification: false,
    //     },
    //     successHandlingConfig: {
    //       showGlobalSuccessMessageNotification: true,
    //     },
    //   },
    //   returnConfig: {
    //     returnSuccessStatus: true,
    //     dataConfig: {
    //       returnData: true,
    //       returnErrorData: true,
    //     },
    //     messagesConfig: {
    //       returnFailureMessage: true,
    //       returnSuccessMessage: true,
    //       returnValidationErrors: true,
    //     },
    //   },
    // }
